export var MOBILE_GUTTER = 2;
export var DESKTOP_GUTTER = 1;
export var MOBILE_COLS = 26;
export var DESKTOP_COLS = 31;
export var DASHBOARD_COLS = 40;
export var getColsNum = function getColsNum(breakpoint, cols) {
  if (!cols) {
    return -1;
  }
  if (typeof cols === 'number' || typeof cols === 'string') {
    return cols;
  }
  return cols[breakpoint] || -1;
};
export var getFlex = function getFlex(total, cols, offset) {
  var styles = '';
  if (cols && cols > 0) {
    var width = "".concat(Math.floor(cols / total * 10e7) / 10e5, "%");
    styles = styles.concat("\n      flex-basis: ".concat(width, ";\n      flex-grow: 0;\n      max-width: ").concat(width, ";\n    "));
  }
  if (offset && offset > 0) {
    styles = styles.concat("\n      margin-left: ".concat(Math.floor(offset / total * 10e7) / 10e5, "%;\n    "));
  }
  return styles;
};
export var getGrid = function getGrid(cols) {
  var startAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
  var styles = '';
  if (startAt && (typeof startAt === 'string' || startAt > 0)) {
    styles = styles.concat("\n      -ms-grid-column: ".concat(startAt, ";\n      grid-column-start: ").concat(startAt, ";\n    "));
  }
  if (cols && cols > 0) {
    styles = styles.concat("\n      -ms-grid-row-span: ".concat(cols, ";\n      grid-column-end: span ").concat(cols, ";\n    "));
  }
  return styles;
};
export var getColsForPosition = function getColsForPosition(totalCols, position, isDesktop) {
  if (!position || totalCols <= 0) {
    return undefined;
  }
  var posValues = position.split('/');
  // Second value is the total amount of items per row
  var totalItems = Number(posValues[1]);
  var gutter = MOBILE_GUTTER;
  if (isDesktop) {
    gutter = DESKTOP_GUTTER;
  }

  // Calculate how many columns the item width should have
  var itemCols = (totalCols - gutter * (totalItems + 1)) / totalItems;
  if (isDesktop && totalItems === 4) {
    // Calculate item styles for this special case (there is an extra columns at each edge)
    itemCols = (totalCols - 2 - gutter * (totalItems + 1)) / totalItems;
  }
  return itemCols;
};
export var getItemsPerRowFlex = function getItemsPerRowFlex(totalCols, position, posOffset, isDesktop) {
  var posValues = position.split('/');
  // First value in fraction is the item order position
  var itemOrder = Number(posValues[0]);
  // Second value is the total amount of items per row
  var totalItems = Number(posValues[1]);
  var gutter = MOBILE_GUTTER;
  if (isDesktop) {
    gutter = DESKTOP_GUTTER;
  }

  // Calculate how many columns the item width should have
  var itemCols = getColsForPosition(totalCols, position, isDesktop);
  var offset;

  // If a custom offset is provided, it needs to be calculated based on the position provided
  if (posOffset) {
    var offsetValues = posOffset.split('/');
    // First value in fraction is the count of items to be left blank
    var offsetCount = Number(offsetValues[0]);
    // Second value is the total amount of items per row
    var offsetTotal = Number(offsetValues[1]);
    var offsetGutter = MOBILE_GUTTER;
    if (isDesktop) {
      offsetGutter = DESKTOP_GUTTER;
    }

    // Calculate how many columns the item width should have
    var offsetItemCols = (totalCols - offsetGutter * (offsetTotal + 1)) / offsetTotal;
    if (isDesktop && offsetTotal === 4) {
      // Set the item offsets for this special case (there is an extra columns at each edge)
      offsetItemCols = (totalCols - 2 - offsetGutter * (offsetTotal + 1)) / offsetTotal;
    }
    offset = offsetCount * offsetItemCols + offsetCount * (offsetGutter + 1);
  } else {
    // Set the item offsets based only on gutters
    offset = gutter;
    if (isDesktop && totalItems === 4) {
      // Set the item offsets for this special case (there is an extra columns at each edge)
      offset = itemOrder === 1 ? gutter + 1 : gutter;
    }
  }
  return getFlex(totalCols, itemCols, offset);
};
export var getItemsPerRowGrid = function getItemsPerRowGrid(totalCols, position, isDesktop) {
  var posValues = position.split('/');
  // First value in fraction is the item order position
  var itemOrder = Number(posValues[0]);
  // Second value is the total amount of items per row
  var totalItems = Number(posValues[1]);
  var gutter = MOBILE_GUTTER;
  if (isDesktop) {
    gutter = DESKTOP_GUTTER;
  }

  // Calculate how many columns the item width should have
  var itemCols = getColsForPosition(totalCols, position, isDesktop) || 0;

  // Calculate where the grid item should start based on order position
  var itemStart = 1 + itemOrder * gutter + (itemOrder - 1) * itemCols;
  if (isDesktop && totalItems === 4) {
    itemStart = 2 + itemOrder * gutter + (itemOrder - 1) * itemCols;
  }
  return getGrid(itemCols, itemStart);
};